"use client";

import type { PaymentMethod, PaymentMockupCopy } from "@/components/landing/Payments/types";
import PaymentBenefits from "@/components/landing/Payments/PaymentBenefits";
import PaymentCheckoutMockup from "@/components/landing/Payments/PaymentCheckoutMockup";
import PaymentMethodsRow from "@/components/landing/Payments/PaymentMethodsRow";
import { MotionReveal, SectionHeader, useSectionMotion } from "@/components/landing/shared";

interface PaymentsInnerProps {
	title: string;
	intro: string;
	benefits: string[];
	methods: PaymentMethod[];
	mockup: PaymentMockupCopy;
}

function PaymentsInner(prop: PaymentsInnerProps) {
	const { title, intro, benefits, methods, mockup } = prop;
	const motion = useSectionMotion();
	return (
		<div className="mx-auto grid max-w-6xl items-center gap-14 px-6 lg:grid-cols-[1fr_0.95fr]">
			<MotionReveal motion={motion}>
				<div>
					<SectionHeader
						title={title}
						subtitle={intro}
						subtitleClassName="mt-4 max-w-lg text-lg leading-relaxed text-muted-foreground"
					/>

					{benefits.length > 0 && <PaymentBenefits benefits={benefits} />}

					{methods.length > 0 && <PaymentMethodsRow methods={methods} />}
				</div>
			</MotionReveal>

			<MotionReveal motion={motion} delayOffset={120}>
				<div className="relative">
					<div
						className="jana-blob absolute -inset-10 opacity-20 blur-3xl"
						style={{ background: "radial-gradient(circle, var(--brand-2), transparent 65%)" }}
					/>
					<div
						className="relative overflow-hidden rounded-[1.75rem] border"
						style={{ borderColor: "var(--border)", boxShadow: "var(--shadow)" }}
					>
						<PaymentCheckoutMockup copy={mockup} />
					</div>
				</div>
			</MotionReveal>
		</div>
	);
}

export default PaymentsInner;
